import React, { Fragment, useState, useEffect } from "react";
import { Btn, H4, H5, H6, Image, P } from "../../../AbstractElements";
import { FaPencilAlt } from "react-icons/fa";
import { Row, Col, CardHeader, CardBody, CardFooter, Form, FormGroup, Input, Card } from "reactstrap";
import axios from "axios";
import { EditProfile, UpdateProfile, EmailAddress, Password } from "../../../Constant";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import apiRequest from "../../../utils/apiRequest";

const EditMyProfile = () => {
  const token = useSelector((state) => state.auth.userToken);

  const [editMode, setEditMode] = useState(false);
  const [url, setUrl] = useState("");
  const [preview, setPreview] = useState('');

  const [userData, setUserData] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
    password: "hello!@#",
    profilePicUrl: "",
  });

  const fetchUserProfile = async () => {
    try {
      const response = await apiRequest(
        'get',
        `${process.env.REACT_APP_API_BASE_URL}/users/profile`,
        {},  // Pass an empty object as data for GET requests
        token
      );
      const { userName, email, phoneNumber, profilePicUrl } = response.data.user;
      setUserData({
        userName,
        email,
        phoneNumber,
        password: "hello!@#",
        profilePicUrl,
      });
      setUrl(profilePicUrl);
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };

  const updateProfile = async () => {
    try {
      const formData = new FormData();
      formData.append("userName", userData.userName);
      formData.append("email", userData.email);
      formData.append("phoneNumber", userData.phoneNumber);
      formData.append("password", userData.password);
      formData.append("profilePicUrl", preview);

      if (url instanceof File) {
        formData.append("file", url);
      }

      // await axios.put(`https://ovah-1-production.up.railway.app/api/auth/updateProfile/${adminId}`, formData, {
      //   headers: {
      //     "Content-Type": "multipart/form-data",
      //   },
      // });

      alert("Profile updated successfully!");
      setEditMode(false);
      fetchUserProfile();
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile.");
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, [token]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUserData({ ...userData, [name]: value });
  };

  const readUrl = async (event) => {
    if (event.target.files.length === 0) return;
    const file = event.target.files[0];
    const mimeType = file.type;
    if (!mimeType.match(/image\/*/)) {
      return;
    }

    setUrl(file); // Store the file object in the state for formData
      setPreview(URL.createObjectURL(file));
    const reader = new FileReader();
    reader.onload = () => {
      setUrl(reader.result); // Update the image preview URL
    };
    reader.readAsDataURL(file);
  };

  const handleImageIconClick = () => {
    editMode && document.getElementById("profile-image-input").click();
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    updateProfile();
  };

  return (
    <Fragment>
      <Form className="card" onSubmit={handleFormSubmit}>
   
        <CardBody>
        <Row className="mb-2">
              <div className="profile-title">
                <div className="media">
                  <img
                      className= "img-70 m-0 rounded-circle"
                      src={url }
                    
                    onClick={ handleImageIconClick}
                  />
                  <label htmlFor="profile-image-input" style={{ display: "none" }}>
                    <FaPencilAlt className="edit-icon" />
                  </label>
                  <input
                    id="profile-image-input"
                    style={{ display: "none" }}
                    className="upload"
                    type="file"
                    onChange={(e) => readUrl(e)}
                  />
                  <div className="media-body">
                    <Link>
                      <H5 attrH5={{ className: "mb-1 text-primary" }}>{userData.userName}</H5>
                    </Link>
                    <P className="text-muted">Admin</P>
                  </div>
                </div>
              </div>
            </Row>

          {!editMode ? (
            <Fragment>
              <Row className="mb-3">
                <Col sm="6">
                  <H6 className="form-label text-secondary">{"User Name"}</H6>
                  <Card className="p-2 border-light shadow-sm">
                    <P className="mb-0">{userData.userName}</P>
                  </Card>
                </Col>
                <Col sm="6">
                  <H6 className="form-label text-secondary">{EmailAddress}</H6>
                  <Card className="p-2 border-light shadow-sm">
                    <P className="mb-0">{userData.email}</P>
                  </Card>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm="6">
                  <H6 className="form-label text-secondary">{"Phone Number"}</H6>
                  <Card className="p-2 border-light shadow-sm">
                    <P className="mb-0">{userData.phoneNumber}</P>
                  </Card>
                </Col>
         
              </Row>
            </Fragment>
          ) : (
            <Fragment>
              <Row>
                <Col sm="6">
                  <FormGroup>
                    <H6 className="form-label">{"User Name"}</H6>
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="User Name"
                      name="userName"
                      value={userData.userName}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
                <Col sm="6">
                  <FormGroup>
                    <H6 className="form-label">{EmailAddress}</H6>
                    <Input
                      className="form-control"
                      type="email"
                      placeholder="Email Address"
                      name="email"
                      value={userData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm="6">
                  <FormGroup>
                    <H6 className="form-label">{"Phone Number"}</H6>
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="Phone Number"
                      name="phoneNumber"
                      value={userData.phoneNumber}
                      onChange={handleInputChange}
                      required
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Fragment>
          )}
        </CardBody>
        <CardFooter className="text-end">
          {editMode ? (
            <Btn attrBtn={{ color: "success", type: "submit" }}>{UpdateProfile}</Btn>
          ) : (
            <FaPencilAlt onClick={() => setEditMode(true)} style={{ cursor: "pointer" }} />
          )}
        </CardFooter>
      </Form>
    </Fragment>
  );
};

export default EditMyProfile;
